'use client'

import { redirectToGDLogin } from '@/lib/redirectToGDLogin'
import { useAppSelector } from '@/redux/store'
import { Redirect } from 'expo-router'
import { Platform } from 'react-native'

export default function IndexPage() {
  const sessionInitialized = useAppSelector(state => state.session.initialized)
  const onboardingInitialized = useAppSelector(state => state.onboarding.initialized)
  const initialized = Platform.OS === 'web' ? sessionInitialized : sessionInitialized && onboardingInitialized

  const signedIn = useAppSelector(state => state.session.signedIn)
  const onboardingCompleted = useAppSelector(state => state.onboarding.completed)

  if (!initialized) return null

  if (Platform.OS !== 'web' && !onboardingCompleted) {
    return <Redirect href="/onboarding" />
  }

  if (!signedIn) {
    if (Platform.OS === 'web') {
      redirectToGDLogin()
      return null
    }
    return <Redirect href="/login" />
  }

  return <Redirect href="/forms" />
}
